require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./poste-1-1-18-2.json") })
        }
      }, "path---poste-1-1-18-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---poste-1-1-18-2!./.cache/json/poste-1-1-18-2.json
// module id = 528
// module chunks = 231608221292675